import { LocalStorageService } from 'ts-storage-service';

const deleteCookiesBasedOnPreferences = () => {
  const ls = new LocalStorageService('cookie');

  const cookiePreferences = ls.getData('settings');

  const analyticalCookies = ['_ym_visorc', 'gdpr', '_ym', 'yabs-sid', 'yandex', 'yashr', 'ymex', 'yp', 'i', 'yuidss', '_yasc', '_ym_d', '_ga', '_gcl', 'AEC', 'IDE', 'NID', '__Secure-YEC', '_gid', '_gat_gtag_UA_'];
  const marketingCookies  = ['bh', 'remix'];

  // A cookie is removed only by the same name + domain + path it was set with, so try every
  // domain (host and its parents) and every path prefix of the current page
  const expireCookie = (name) => {
    const hostParts = location.hostname.split('.');
    const domains   = [''];
    const pathParts = location.pathname.split('/').filter(Boolean);
    const paths     = ['/'];

    for (let i = 0; i < hostParts.length - 1; i++) {
      domains.push(`; domain=${hostParts.slice(i).join('.')}`, `; domain=.${hostParts.slice(i).join('.')}`);
    }

    pathParts.forEach((part, index) => {
      paths.push(`/${pathParts.slice(0, index + 1).join('/')}`);
    });

    domains.forEach((domain) => {
      paths.forEach((path) => {
        document.cookie = `${name}=; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domain}`;
      });
    });
  };

  const deleteCookies = (cookieNames) => {
    const names = document.cookie.split(';').map((cookie) => cookie.split('=')[0].trim()).filter(Boolean);

    names.forEach((name) => {
      if (!cookieNames || cookieNames.some((cookieName) => new RegExp(`^${cookieName}.*`, 'i').test(name))) {
        expireCookie(name);
      }
    });
  };

  if (cookiePreferences && !cookiePreferences.analytical_cookie && !cookiePreferences.marketing_cookie) {
    // Everything optional is refused: the site sets no cookies from JS itself, so wipe all the JS can reach
    deleteCookies();
    return;
  }

  if (cookiePreferences && !cookiePreferences.analytical_cookie) {
    deleteCookies(analyticalCookies);
    return;
  }

  if (cookiePreferences && !cookiePreferences.marketing_cookie) {
    deleteCookies(marketingCookies);
  }
};

export default deleteCookiesBasedOnPreferences;